<!--use a s sample to build out new route/child route logic-->
<template>
    <v-main v-if="org">
        <v-card>
            <v-card-title>
                {{org.info.fullname}} Storefront
            </v-card-title>
            <v-container>
                <v-row v-if="org.userpool">
                    <v-col v-for="t in tiles"   :key="t.to">
                        <v-card  :to="t.to" outlined height="70" >
                            <v-card-text>
                                <div class="text-center">
                                    <v-icon>{{icons[t.icon]}}</v-icon>
                                </div>
                                <div class="text-center">{{t.name}}</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <router-view></router-view>
    </v-main>
</template>

<script>
  const PATH = '/storefront' //im lazy and hate writing `"organi....
  import {
    mapState,
    mapActions
  } from 'vuex'
  export default {
    name: "Index",
    data() {
      return {
        search:undefined,
        dialog:false,
        products:[],
        activeproduct:false,
        price1:undefined,
        menu: true,
        tiles:[
          {to: PATH+'/products', icon: 'home', name: 'products'},
          {to: PATH+'/editproduct/:productid', icon: 'storefront', name: 'Edit Product'}
        ]
      }
    },
    computed:{
      ...mapState(['org','icons']),
    },
    mounted() {
    },
    methods: {
      ...mapActions(['get','post','putAppOrg','dedlete','put']),
    }
  }
</script>

<style scoped>

</style>